import { FC, Fragment } from 'react';
import { Link } from 'react-router-dom';
// Types
import UserRoles from 'types/UserRoles';
// Models
import { IUser } from 'models/User';
// Components
import { Button } from 'components/Buttons';

type Props = {
  currentUser: IUser;
}

const PrivateContent:FC<Props> = ({
  currentUser
}) => {
  const roles:Array<string> = Object.values(UserRoles).map((role:UserRoles) => role);
  return (
    <Fragment>
      <h1
        className="text-white text-4xl font-semibold mb-8"
        style={{
          textShadow: '6px 0 8px rgba(0,0,0,0.38)'
        }}
      >{`Welcome, ${currentUser.name}`}</h1>
      <h3
        className="text-white text-2xl mb-8"
        style={{
          textShadow: '6px 0 8px rgba(0,0,0,0.38)'
        }}
      >
        You`re signed in as a <span className="font-semibold">{currentUser.groups.join(', ') || 'client'}</span> using the email address <span className="font-semibold">{currentUser.email}</span>
      </h3>
      {currentUser.groups.some((group:string) => roles.includes(group)) ? (
        <Fragment>
          <div className="mb-4">
            <Button
              className="w-9/12"
              component={Link} to="/owner/quizzes"
              variant="contained"
              size="xl"
            >Manage Games</Button>
          </div>
          <div>
            <Button
              className="w-9/12"
              component={Link} to="/owner/groups"
              variant="outlined"
              size="xl"
            >Manage Game Groups</Button>
          </div>
        </Fragment>
      ) : null}
    </Fragment>
  )
}

export default PrivateContent;
